import { Box, Typography } from '@mui/material';
import { LockIcon } from '../../assets/icons/icons';

export default function StepTab({ step, isActive, isDisabled, isHidden, onClick, tabRef }) {
  if (isHidden) {
    return null;
  }

  return (
    <Box
      ref={tabRef}
      role="tab"
      id={`electrify-tab-${step.id}`}
      aria-selected={isActive}
      aria-controls={`electrify-panel-${step.id}`}
      tabIndex={isDisabled ? -1 : 0}
      component="button"
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: { xs: 1.5, sm: 2 },
        px: { xs: 0.5, sm: 1 },
        border: 'none',
        borderBottom: '2px solid',
        borderColor: isActive ? 'blue.450' : 'transparent',
        bgcolor: isActive ? 'common.white' : 'blue.450',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: isActive ? 'blue.450' : 'common.white',
          outlineOffset: '-2px',
          zIndex: 1,
        },
      }}
    >
      <Typography
        variant="body1"
        component="span"
        fontWeight={600}
        color={isActive ? 'blue.450' : 'common.white'}
        textAlign="center"
        lineHeight={1.3}
        sx={{ display: { xs: 'none', sm: 'flex', alignItems: 'center' }, height: '100%' }}
      >
        {step.label}
        <Typography
          component="span"
          aria-label="Disabled"
          display="flex"
          alignItems="center"
          ml={0.5}
        >
          {isDisabled && <LockIcon />}
        </Typography>
      </Typography>
    </Box>
  );
}
